import type React from 'react';
import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import SuggestedEditIcon from '@atlaskit/icon-lab/core/suggested-edit';

import { Ati } from '@atlassian/ari';

import { SMART_CREATE_PROMPT } from '@confluence/named-routes';

import type { UseMenuItemProps, UseMenuItemReturnProps } from '.';

import { useHybridLinkClick } from '../../CreateContentPopover/CreateContentPopoverItems/hybridLinkHelper';

const i18n = defineMessages({
	smartCreateTitle: {
		id: 'create-blank-fabric-page.create.content.smart-create.title',
		defaultMessage: 'Get started with AI',
		description: 'title indicating that this option will trigger an AI guided creation workflow',
	},
});

/**
 * This is a menu item for an internal demo/spike of a new AI powered creation workflow.
 */
export function useAISmartCreateItem({
	spaceKey,
	onClick,
}: UseMenuItemProps): UseMenuItemReturnProps {
	const { formatMessage } = useIntl();

	const createHref = SMART_CREATE_PROMPT.toUrl(undefined, { query: { spaceKey } });

	const hybridPageLinkClick = useHybridLinkClick(createHref);

	const handleClick = useCallback(
		(e: React.MouseEvent | React.KeyboardEvent) => {
			onClick('createAISmartCreatePopoverItem');
			hybridPageLinkClick(e);
		},
		[onClick, hybridPageLinkClick],
	);

	return {
		ati: Ati.parse('ati:cloud:confluence:page'), // todo: this is incorrect, we don't know the type identifier yet
		children: formatMessage(i18n.smartCreateTitle),
		onClick: handleClick,
		elemBefore: SuggestedEditIcon,
		href: createHref,
		testId: `create-menu-link-item`,
	};
}
